import React, { useState } from "react";

import { EffortList } from "./";

export default function EffortManagement({
  campaignId,
  locationId,
  organizationId,
}) {
  const [refresh, setRefresh] = useState(false);

  const requestInfo = {
    url: `/retrieve-efforts/`,
    data: {
      location_id: locationId,
      campaign_id: campaignId,
      organization_id: organizationId,
      refresh,
      skinny_collection: true,
    },
  };

  return <EffortList requestInfo={requestInfo} />;
}
